module.exports = __webpack_public_path__ + "static/mobile-membership-0ae95434b512998803f8535fe92aefa2.png";